import { useMutation, useQuery } from "@tanstack/react-query";
import { queryClient } from "client";
import { useEffect, useState } from "react";
import axiosInstance from "utils/axios";
import { decrypt } from "utils/crypto";

const getUserApplication = async (major) => {
  return axiosInstance
    .get(`/application/${major}`)
    .then((res) => res.data)
    .catch((err) => err.response.data);
};

export const useGetApplication = (major) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["application", major],
    queryFn: () => getUserApplication(major),
  });
  const [application, setApplication] = useState(data);

  useEffect(() => {
    if (data?.data) {
      setApplication(decrypt(data.data));
    }
  }, [data]);
  return { data: application, isLoading, error };
};

const applyForMajor = async (data) => {
  return axiosInstance
    .post("/application/create", { ...data, time: new Date() })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};

export const useApplyForMajor = () => {
  return useMutation({
    mutationFn: applyForMajor,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["application"],
      });
    },
  });
};

const withdrawApplication = async (id) => {
  return axiosInstance
    .delete(`/application/${id}`)
    .then((res) => res.data)
    .catch((err) => err.response.data);
};

export const useWithdrawApplication = () => {
  return useMutation({
    mutationFn: (id) => withdrawApplication(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["application"],
      });
    },
  });
};
